import { useState } from "react";
import { BedsData, PhonesData } from "../../NurseMgmtDataModels";
import { NurseManagementService } from "../../NurseManagementService";

interface NurseMgmtUpdateData {
    unitId: string,
    nurseId: string,
    bedList: number[],
    phoneNumber?: string
}

const useNurseManagementDataUpdate = () => {
    const [nurseMgmtUpdateData, setNurseMgmtUpdateData]: [NurseMgmtUpdateData[], Function] = useState([]);

    const resetUpdateData = () => {
        setNurseMgmtUpdateData([]);
    }
    const getInitialBedsArr = (nurseGuid: string, currentSelectedBedId: number): number[] => {
        const initialBedList = NurseManagementService.getInitialList('bed') || [];
        if (initialBedList.length === 0) return [];
        const bedsListArr:any =initialBedList.filter((bed: BedsData | PhonesData) => bed?.assigned_status?.guid?.includes(nurseGuid))?.map((bed:any)=>bed?.id);
        return bedsListArr;
    }

    const getInitialPhone = (nurseGuid: string): string => {
        const initialPhoneList: BedsData[] | PhonesData[] = NurseManagementService.getInitialList('phone') || [];
        if (initialPhoneList.length === 0) return '';
        const phone: PhonesData[] | BedsData[] = (initialPhoneList as PhonesData[]).filter((phone: PhonesData | BedsData) => {
            return ((phone as PhonesData).assigned_status === nurseGuid);
        });
        return phone.length ? ((phone as PhonesData[])[0]).id.toString() : '';
    }

    const getNurseObjIfExistsInUpdateArr = (nurseId: string): NurseMgmtUpdateData[] => {
        if (nurseMgmtUpdateData.length === 0) return [];
        return nurseMgmtUpdateData.filter(nurseObj => {
            return nurseObj.nurseId === nurseId;
        });
    }

    const addDelBedsArr = (bedsArr: number[], action: string, id: number) => {
        if (action === 'add') {
            bedsArr.push(id);
        }
        if (action === 'del') {
            const bedIdIndex = bedsArr.indexOf(id);
            bedIdIndex >= 0 && bedsArr.splice(bedIdIndex, 1);
        }
    }

    const setNurseUpdateData = (unitId: string, nurseId: string, phoneNumberObj: { number: string, id: number }, bedObj: { id: number, action: string }, nurseGuid: string, source: string): void => {
        const nurseObjArr = getNurseObjIfExistsInUpdateArr(nurseId);
        if (nurseObjArr.length) {
            if (source === 'phone')
                nurseObjArr[0].phoneNumber = phoneNumberObj.number ? phoneNumberObj.id.toString() : '';
            if (source === 'bed') addDelBedsArr(nurseObjArr[0].bedList, bedObj.action, bedObj.id);
            setNurseMgmtUpdateData([...nurseMgmtUpdateData]);
        } else {
            let nurseObjInUpdate = ({} as NurseMgmtUpdateData);
            if (source === 'phone') {
                nurseObjInUpdate = {
                    unitId: unitId,
                    nurseId: nurseId,
                    bedList: getInitialBedsArr(nurseGuid, bedObj.id),
                    phoneNumber: phoneNumberObj.number ? phoneNumberObj.id.toString() : ''
                }
            }
            if (source === 'bed') {
                nurseObjInUpdate = {
                    unitId: unitId,
                    nurseId: nurseId,
                    bedList: getInitialBedsArr(nurseGuid, bedObj.id),
                    phoneNumber: getInitialPhone(nurseGuid)
                }
                // addDelBedsArr(nurseObjInUpdate.bedList, bedObj.action, bedObj.id);
            }
            setNurseMgmtUpdateData([...nurseMgmtUpdateData, nurseObjInUpdate]);
        }
    }
    return ({ nurseMgmtUpdateData, setNurseUpdateData, resetUpdateData });
}

export default useNurseManagementDataUpdate;